/**
 * RouteFallback — Suspense boundary used while a code-split route chunk loads.
 *
 * Apple-quiet: a soft shimmer panel rather than a spinner, so first-paint of
 * the new route never feels like a stutter. Designed to take the same vertical
 * footprint as a typical page so layout doesn't jump when content arrives.
 */

import { Skeleton } from '@/components/ui/skeleton';

export function RouteFallback() {
  return (
    <div
      className="min-h-screen bg-background"
      aria-busy="true"
      aria-live="polite"
    >
      <div className="mx-auto max-w-7xl space-y-6 px-4 py-8 sm:px-6 lg:px-8">
        {/* Header row */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Skeleton className="size-9 rounded-md" />
            <div className="space-y-2">
              <Skeleton className="h-4 w-40" />
              <Skeleton className="h-3 w-64" />
            </div>
          </div>
          <Skeleton className="h-8 w-24 rounded-md" />
        </div>

        {/* Content card */}
        <Skeleton className="h-72 w-full rounded-lg" />

        {/* Secondary card */}
        <Skeleton className="h-48 w-full rounded-lg" />
      </div>
    </div>
  );
}
